/* ===========================================
   DOT PHONE CAROUSEL — Castle Street Media
=========================================== */
(function () {
  'use strict';

  const cfgEl = document.querySelector('.dpc-config');
  if (!cfgEl) return;

  const SID         = cfgEl.dataset.sid;
  const DOT_SPACING = parseFloat(cfgEl.dataset.dotSpacing);
  const DOT_RADIUS  = parseFloat(cfgEl.dataset.dotSize);
  const DOT_COLOR   = cfgEl.dataset.dotColor;
  const ACCENT      = cfgEl.dataset.accent;

  const section  = document.getElementById('dpc-' + SID);
  const canvas   = document.getElementById('dpc-canvas-' + SID);
  const track    = document.getElementById('dpc-track-' + SID);
  const navWrap  = document.getElementById('dpc-nav-' + SID);
  if (!section || !canvas || !track) return;

  const ctx     = canvas.getContext('2d');
  const slides  = Array.from(track.querySelectorAll('.dpc-slide'));
  const navDots = navWrap ? Array.from(navWrap.querySelectorAll('.dpc-nav-dot')) : [];

  const FORCE_R    = 200;
  const PULL_FORCE = 55;
  const IS_MOBILE  = window.innerWidth <= 600;

  let dots           = [];
  let activeIdx      = 0;
  let mouse          = { x: -9999, y: -9999 };
  let phonePositions = [];
  let raf;

  function resize() {
    canvas.width  = section.offsetWidth;
    canvas.height = section.offsetHeight;
    buildDots();
  }

  function buildDots() {
    dots = [];
    const cols = Math.ceil(canvas.width  / DOT_SPACING) + 1;
    const rows = Math.ceil(canvas.height / DOT_SPACING) + 1;
    const offX = (canvas.width  % DOT_SPACING) / 2;
    const offY = (canvas.height % DOT_SPACING) / 2;
    for (let r = 0; r < rows; r++)
      for (let c = 0; c < cols; c++)
        dots.push({ ox: offX + c * DOT_SPACING, oy: offY + r * DOT_SPACING });
  }

  function updatePhonePositions() {
    const sr = section.getBoundingClientRect();
    phonePositions = slides.map(s => {
      const r = s.getBoundingClientRect();
      return { x: r.left + r.width / 2 - sr.left, y: r.top + r.height * 0.45 - sr.top };
    });
  }

  function getActiveIndex() {
    const sr = section.getBoundingClientRect();
    const cx = sr.width / 2;
    let best = 0, bestD = Infinity;
    slides.forEach((s, i) => {
      const r = s.getBoundingClientRect();
      const d = Math.abs(r.left + r.width / 2 - sr.left - cx);
      if (d < bestD) { bestD = d; best = i; }
    });
    return best;
  }

  function lerp(a, b, t) { return a + (b - a) * t; }

  function hexToRgb(hex) {
    if (!hex) return null;
    if (hex.startsWith('rgb')) { const m = hex.match(/\d+/g); return m ? [+m[0],+m[1],+m[2]] : null; }
    hex = hex.replace('#', '');
    if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
    if (hex.length !== 6) return null;
    return [parseInt(hex.slice(0,2),16), parseInt(hex.slice(2,4),16), parseInt(hex.slice(4,6),16)];
  }

  function lerpColor(ca, cb, t) {
    const a = hexToRgb(ca), b = hexToRgb(cb);
    if (!a || !b) return ca;
    return `rgb(${Math.round(lerp(a[0],b[0],t))},${Math.round(lerp(a[1],b[1],t))},${Math.round(lerp(a[2],b[2],t))})`;
  }

  function parseDotColor(col) {
    if (col.startsWith('#')) return col;
    const m = col.match(/\d+/g);
    return m ? '#' + [m[0],m[1],m[2]].map(v => parseInt(v).toString(16).padStart(2,'0')).join('') : '#555555';
  }

  function smoothstep(a, b, x) {
    const t = Math.max(0, Math.min((x - a) / (b - a), 1));
    return t * t * (3 - 2 * t);
  }

  function draw() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    const ap = phonePositions[activeIdx];
    if (!ap) return;

    for (let i = 0; i < dots.length; i++) {
      const d = dots[i];
      let px = d.ox, py = d.oy;

      for (let pi = 0; pi < phonePositions.length; pi++) {
        const pp = phonePositions[pi];
        const isA = pi === activeIdx;
        const dx = pp.x - d.ox, dy = pp.y - d.oy;
        const dist = Math.sqrt(dx*dx + dy*dy);
        if (dist < 0.001 || dist > FORCE_R * (isA ? 1.4 : 0.6)) continue;
        const pull = smoothstep(FORCE_R * (isA ? 1.4 : 0.6), 0, dist) * PULL_FORCE * (isA ? 1.0 : 0.12);
        px += (dx / dist) * pull;
        py += (dy / dist) * pull;
      }

      const mdx = d.ox - mouse.x, mdy = d.oy - mouse.y;
      const md  = Math.sqrt(mdx*mdx + mdy*mdy);
      if (md > 0 && md < 120) { const mf = smoothstep(120, 0, md) * 40; px += (mdx/md)*mf; py += (mdy/md)*mf; }

      const adx = d.ox - ap.x, ady = d.oy - ap.y;
      const ad  = Math.sqrt(adx*adx + ady*ady);
      const tC  = Math.max(0, 1 - ad / (FORCE_R * 1.2));
      const tS  = Math.max(0, 1 - ad / (FORCE_R * 0.8));
      const r   = DOT_RADIUS + tS * DOT_RADIUS * 1.6;

      ctx.globalAlpha = 0.2 + tC * 0.65;
      ctx.fillStyle   = tC > 0.01 ? lerpColor(parseDotColor(DOT_COLOR), ACCENT, tC * 0.8) : DOT_COLOR;
      ctx.beginPath();
      ctx.arc(px, py, r, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.globalAlpha = 1;
  }

  function updateSlides() {
    const ai = getActiveIndex();
    if (ai !== activeIdx) {
      activeIdx = ai;
      navDots.forEach((d, i) => d.classList.toggle('is-active', i === ai));
      const rgb = hexToRgb(ACCENT);
      if (rgb) slides[ai].style.setProperty('--dpc-active-glow', `rgba(${rgb.join(',')},0.4)`);
    }
    slides.forEach((s, i) => {
      const dist = Math.abs(i - ai);
      s.style.transform = `scale(${dist === 0 ? 1 : dist === 1 ? 0.88 : 0.78})`;
      s.style.opacity   = dist === 0 ? 1 : dist === 1 ? 0.65 : 0.4;
      s.classList.toggle('is-active', i === ai);
    });
  }

  function loop() {
    raf = requestAnimationFrame(loop);
    updatePhonePositions();
    updateSlides();
    if (!IS_MOBILE) draw();
  }

  /* ── Desktop mouse drag only ── */
  let dragStartX = 0, scrollStart = 0, isDragging = false, velX = 0, lastX = 0, lastT = 0;

  function startDrag(e) {
    isDragging  = true;
    dragStartX  = e.pageX;
    scrollStart = track.scrollLeft;
    velX = 0; lastX = dragStartX; lastT = Date.now();
    track.classList.add('grabbing');
  }
  function moveDrag(e) {
    if (!isDragging) return;
    track.scrollLeft = scrollStart + (dragStartX - e.pageX) * 1.1;
    const now = Date.now();
    velX  = (e.pageX - lastX) / Math.max(1, now - lastT);
    lastX = e.pageX; lastT = now;
  }
  function endDrag() {
    if (!isDragging) return;
    isDragging = false;
    track.classList.remove('grabbing');
    if (Math.abs(velX) > 0.5) track.scrollBy({ left: -velX * 60, behavior: 'smooth' });
  }

  /* Mouse only — no touch interference at all on mobile */
  track.addEventListener('mousedown',  startDrag);
  track.addEventListener('mousemove',  moveDrag);
  track.addEventListener('mouseup',    endDrag);
  track.addEventListener('mouseleave', endDrag);

  /* ── Nav dots ── */
  if (navWrap) {
    navWrap.addEventListener('click', e => {
      const btn = e.target.closest('.dpc-nav-dot');
      if (btn) scrollToSlide(parseInt(btn.dataset.i, 10));
    });
  }

  function scrollToSlide(idx) {
    const slide = slides[idx]; if (!slide) return;
    const tr = track.getBoundingClientRect(), sr = slide.getBoundingClientRect();
    track.scrollTo({ left: track.scrollLeft + (sr.left - tr.left) - (track.clientWidth / 2 - slide.offsetWidth / 2), behavior: 'smooth' });
  }

  document.addEventListener('keydown', e => {
    const r = section.getBoundingClientRect();
    if (r.top > window.innerHeight || r.bottom < 0) return;
    if (e.key === 'ArrowRight') scrollToSlide(Math.min(activeIdx + 1, slides.length - 1));
    if (e.key === 'ArrowLeft')  scrollToSlide(Math.max(activeIdx - 1, 0));
  });

  section.addEventListener('mousemove', e => {
    const r = section.getBoundingClientRect();
    mouse.x = e.clientX - r.left; mouse.y = e.clientY - r.top;
  }, { passive: true });
  section.addEventListener('mouseleave', () => { mouse.x = -9999; mouse.y = -9999; });

  /* ── Init ── */
  resize();

  if (IS_MOBILE) {
    canvas.style.display = 'none';
    updateSlides();
    setInterval(updateSlides, 200);
  } else {
    loop();
  }

  requestAnimationFrame(() => scrollToSlide(0));

  let resizeTO;
  window.addEventListener('resize', () => { clearTimeout(resizeTO); resizeTO = setTimeout(resize, 120); });

  if (window.IntersectionObserver) {
    new IntersectionObserver(entries => {
      entries.forEach(e => { if (!e.isIntersecting) cancelAnimationFrame(raf); else if (!IS_MOBILE) loop(); });
    }, { threshold: 0.1 }).observe(section);
  }

})();